import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const DonutChartCard = ({ title, data }) => {
  // Check if data is empty or has no meaningful values
  const hasData = data && data.length > 0 && data.some(d => d.value > 0);
  
  // Empty placeholder data for the grey donut
  const emptyData = [{ value: 1, color: "#d1d5db" }];
  const chartData = hasData ? data : emptyData;

  return (
    <div >
      <h3 className="font-semibold mb-4">{title}</h3>
      <div className="flex justify-center">
        <PieChart width={160} height={160}>
          <Pie
            data={chartData}
            innerRadius={55}
            outerRadius={65}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            isAnimationActive={false}
          >
            {chartData.map((entry, index) => (
              <Cell key={index} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </div>
      <div className="text-list-container">
        {data && data.map((d, i) => (
          <div key={i} className="text-item">
            <span
              className="color-box"
              style={{ backgroundColor: d.color }}
            ></span>
            <span className="text-label" title={d.label}>
              {d.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChartCard;
